import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';

export const IGNORE_EXPIRATION_KEY = 'keysToIgnoreExpiration'
export interface ExpiredApiKey {
  label: string
  key: string
  isExpired: boolean
  formattedDate: string
}
export interface DialogData {
  userKeys?: ExpiredApiKey[]
  deviceKeys?: ExpiredApiKey[]
}

@Component({
  host: {
    'class': 'mat-dialog-component',
    'test-id': 'expired-api-keys-dialog',
  },
  selector: 'expired-api-keys-dialog',
  templateUrl: './expired-api-keys-dialog.component.html',
  styleUrls: ['./expired-api-keys-dialog.component.scss'],
})
export class ExpiredApiKeysDialogComponent {
  userKeys: ExpiredApiKey[]
  deviceKeys: ExpiredApiKey[]
  doNotShow = false

  constructor(
    @Inject(DIALOG_DATA) public data: DialogData,
    private dialogRef: DialogRef<ExpiredApiKeysDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.userKeys = this.data?.userKeys || [];
    this.deviceKeys = this.data?.deviceKeys || [];
  }

  updateIgnoredKeys(): void {
    const keysToIgnore = [...this.userKeys.map(k => k.key), ...this.deviceKeys.map(k => k.key)];
    let ignoredKeys = [];
      try {
        const allIgnoredKeys = new Set([...JSON.parse(localStorage.getItem(IGNORE_EXPIRATION_KEY)), ...keysToIgnore]);
        ignoredKeys = [...allIgnoredKeys];
      } catch (error) {
        ignoredKeys = keysToIgnore;
      }
      localStorage.setItem(IGNORE_EXPIRATION_KEY, JSON.stringify(ignoredKeys));
  }

  close(): void {
    if (this.doNotShow) {
      this.updateIgnoredKeys();
    }
    this.dialogRef.close();
  }
}
